module.exports = __webpack_public_path__ + "static/media/info_panel.39df78c2.svg";